export const ARIA_ATTRIBUTES = {
  'aria-describedby': 'country-info-message',
};

export const BATCHED_QUERY_OPTIONS_OVERRIDES = {
  context: {
    isBatchedQuery: true,
  },
};

/**
 * isPageLoading: We don't want to hide the page spinner until all
 * operations are finished, so we reset the store with the page spinner
 * shown.
 *
 * showVenmoMessage: This interstital message is only shown on initial
 * page load. The user has already opted to pay with PayPal so we don't
 * need to show the popup again.
 */
const RESET_STORE_OVERRIDES_DEFAULT = {
  ui: {
    isPageLoading: true,
    showVenmoMessage: false,
  },
};

/**
 * used as parameter to queryInitialData when user is getting
 * redirected to /landing route to /signup route
 * isPageLoading - is set to false as there is another loading spinner
 * on /landing page
 * showVenmoMessage - setting it to false as we dont take venmo traffic
 * for /landing route for initial ramp
 */
const RESET_STORE_OVERRIDES_LANDING_TO_BILLING = {
  ui: {
    isPageLoading: false,
    showVenmoMessage: false,
  },
};

export const RESET_STORE_OVERRIDES_MAPPER = {
  default: RESET_STORE_OVERRIDES_DEFAULT,
  landingToBilling: RESET_STORE_OVERRIDES_LANDING_TO_BILLING,
};
